import { url } from "./misc";
import Cookies from 'js-cookie';

export async function Auth(tenant) {
    const endpoint = url + "/api/zia/authentication"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'tenant': tenant,
        },
        body: JSON.stringify(requestData),
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response.json();

};

export async function SignOut(JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/signout";
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response.json();

}


export async function AddUserToGroup(user, group, tenant, JSESSIONID) {
    const endpoint = url + "/api/zia/groups/add"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        "group": group,
        "user": user
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            "Tenant": tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

export async function RemoveUserFromGroup(user, group, tenant, JSESSIONID) {
    const endpoint = url + "/api/zia/groups/remove"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        "group": group,
        "user": user,
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            "Tenant": tenant

        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

// Phase 1: resolve the selected group names and find all their members.
export async function PlanDeleteGroups(groups, tenant) {
    const JWT = Cookies.get('CF_Authorization');
    return fetch(url + "/api/zia/groups/delete/plan", {
        method: 'POST',
        headers: { 'JWT': JWT, "Tenant": tenant },
        body: JSON.stringify({ "groups": groups }),
    });
}

// Phase 2: remove the selected groups from a chunk of users.
export async function RemoveGroupMembers(userIds, groupIds, tenant) {
    const JWT = Cookies.get('CF_Authorization');
    return fetch(url + "/api/zia/groups/delete/remove", {
        method: 'POST',
        headers: { 'JWT': JWT, "Tenant": tenant },
        body: JSON.stringify({ "userIds": userIds, "groupIds": groupIds }),
    });
}

// Phase 3: delete a chunk of the now-empty groups. activateMembers (first chunk)
// applies the membership removals first; activateDelete (last chunk) applies the deletes.
export async function FinalizeDeleteGroups(groups, removedUsers, tenant, activateMembers, activateDelete) {
    const JWT = Cookies.get('CF_Authorization');
    return fetch(url + "/api/zia/groups/delete/finalize", {
        method: 'POST',
        headers: { 'JWT': JWT, "Tenant": tenant },
        body: JSON.stringify({ "groups": groups, "removedUsers": removedUsers, "activateMembers": activateMembers, "activateDelete": activateDelete }),
    });
}

export async function CheckGroupName(group, JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/groups/check"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        "group": group
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

export async function CheckGroupMembership(user, group, JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/groups/ismember"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        "group": group,
        "user": user
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

export async function ListGroupMembers(group, JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/groups/members"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        "group": group
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

export async function ListGroups(JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/groups/list"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}

export async function GetUser(user, JSESSIONID, tenant) {
    const endpoint = url + "/api/zia/users/get"
    const JWT = Cookies.get('CF_Authorization');
    // Define the request parameters
    const requestData = {
        'user': user
    };

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,

            'JSESSIONID': JSESSIONID.toString(),
            'Tenant': tenant
        },
        body: JSON.stringify(requestData),
    };
    // Make the HTTP request
    return fetch(endpoint, requestOptions);
}